export function throwSentrySourceMapSmoke(): never {
  throw new Error('nextup-web-sourcemap-smoke');
}

type ScheduleTask = (task: () => void) => unknown;

function schedulePageTask(task: () => void): void {
  setTimeout(task, 0);
}

export function triggerSentrySourceMapSmoke(
  scheduleTask: ScheduleTask = schedulePageTask
): void {
  scheduleTask(throwSentrySourceMapSmoke);
}

export function installSentrySourceMapSmoke({
  vercelBuild,
  vercelEnv,
  target,
  trigger = triggerSentrySourceMapSmoke,
}: {
  vercelBuild?: string;
  vercelEnv: string | undefined;
  target: object;
  trigger?: () => void;
}): void {
  if (vercelBuild !== '1' || vercelEnv !== 'preview') return;

  Object.assign(target, {
    nextupSentrySourceMapSmoke: trigger,
  });
}
